import Vue from 'vue';
import VueRouter from 'vue-router'
import Layout from '../components/layout/index.vue';


Vue.use(VueRouter)

const routes = [   
  {
    path: '',
    component: Layout,
    redirect: '/gather',
    children: [
      {
        path: '/gather',
        name: 'fileCollect',
        component: () => import(/* webpackChunkName: "fileCollect" */ '@/views/fileCollect.vue')
      },
      {
        path: '/login',
        name: 'login',
        component: () =>
          import(/* webpackChunkName: "login" */ '../views/login.vue'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
